import moment, { Moment } from 'moment'
import {
  AccountInfoDto,
  BlockOffEmployee,
  BOOKING_TYPE,
  ServiceCategoryDto,
  TaskDto,
  VendorInfoDto
} from '../../../../../definition'
import { ScheduleCalendarConfigurationType } from '../../../../../definition/time-slot.dto'
import defaultAvatar from './../../../../../styles/images/default-avatar.jpg'
import getTaskStatus from '../../../../components/task-status.component'
import { renderDesignateAddress } from '../../../../../utils'
import { NavLink } from 'react-router-dom'
import { getDayNumberFromString } from '../../../../../utils/datetime'
import ClockIcon from './../../../../../styles/images/clock.png'
import { checkIsBlockDaily, checkIsBlockDailyPartial } from '../../../../../utils/booking-util'
import { appEventEmitter } from '../../../../../initialization'
import { ModalNode } from '../../../../components/modal.component'
import { APP_EVENTS } from '../../../../../constants'
import { BlockOffItemModal } from '../block-off-item'

type ScheduleCalendarDailyPropType = {
  tasks: TaskDto[]
  configuration?: ScheduleCalendarConfigurationType
  weekStart?: string
  date: Moment
  vendors: VendorInfoDto[]
  technicians: AccountInfoDto[]
  mainCategories: ServiceCategoryDto[]
  selectedMainCategoryId: string[]
  selectedVendorId: string[]
  refreshSchedule: () => void // Add this new prop
}

const thisHour = new Date().getHours()
const startHour = 8
const endHour = 22

const ScheduleCalendarDaily = (props: ScheduleCalendarDailyPropType) => {
  const groupByTech = Object.groupBy(props.tasks, ({ assignee }) => assignee?.profile?.name || 'unassign')
  const techDontHaveTask = props.technicians
    .filter((tech) => !groupByTech[tech.profile?.name as string])
    .filter((tech) => {
      if (props.selectedVendorId.length === 0) {
        return true
      } else {
        if (tech?.companyId && props.selectedVendorId.includes(tech?.companyId)) {
          return true
        } else return false
      }
    })

  const onSeeBlockTime = (block: BlockOffEmployee) => {
    appEventEmitter.emit<ModalNode>(APP_EVENTS.app_modal, {
      input: {
        block: block,
        technicians: props.technicians,
        date: moment(props.date).format('YYYY-MM-DD'),
        refreshSchedule: props.refreshSchedule
      },
      status: true,
      node: BlockOffItemModal,
      title: 'Blocked Time',
      onClose: () => {},
      onDone: () => {}
    })
  }

  const rangeHour = new Array(24)
    .fill(0)
    .map((_, index) => {
      return {
        hour: index
      }
    })
    .filter(({ hour }) => hour >= startHour && hour <= endHour)

  const dayIndex = moment(props.date).get('day') === 0 ? 7 : moment(props.date).get('day')

  return (
    <div className='schedule-wrapper-daily'>
      <div className='table'>
        {[{ hour: 999 }, ...rangeHour].map(({ hour }) => {
          const isThisHour = thisHour === hour

          if (hour === 999) {
            return (
              <div className='column sticky daily-left-bar'>
                <div className='heading' style={{ zIndex: 1000 }}>
                  <img src={ClockIcon} alt='clock' width={24} />
                </div>
                {Object.keys(groupByTech)
                  .filter((key) => key !== 'unassign')
                  .map((key) => {
                    const task = props.tasks.find((task) => task.assignee?.profile?.name === key)

                    const mainCategory = props.mainCategories.find(
                      (cat) => task?.company?.mainCategoryId === cat.id
                    )?.name

                    const vendor = props.vendors.find((vendor) => vendor.id === task?.companyId)
                    const tech = props.technicians.find((tech) => tech?.profile?.name === key)

                    const { isBlock, block } = checkIsBlockDaily(tech?.blockOffEmployees || [], props.date)

                    return (
                      <div className='side-technician-item tech-info' key={key}>
                        <img src={task?.assignee?.profile?.avatarUrl || defaultAvatar} alt='tech' />
                        <div className='tech-info-title'>
                          <div style={{ fontWeight: 600, fontSize: 14 }}>{key}</div>
                          <div style={{ fontWeight: 400, fontSize: 12 }}>{mainCategory}</div>
                          <div style={{ fontWeight: 400, fontSize: 12 }}>{task?.company?.name}</div>
                        </div>
                        {isBlock && block && (
                          <div
                            onClick={() => {
                              onSeeBlockTime(block)
                            }}
                            className='rest-block'
                            style={{ width: `${((endHour - startHour) * 100) / 2}%` }}
                          >
                            {block.reason || 'Time Block'}
                            <div>{`0${startHour}:00-${endHour + 1}:00`}</div>
                          </div>
                        )}
                      </div>
                    )
                  })
                  .concat(
                    techDontHaveTask
                      .filter((tech) => props.vendors.find((vendor) => vendor.id === tech.companyId))
                      .filter((tech) => {
                        if (props.selectedMainCategoryId.length === 0) {
                          return true
                        }
                        const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                        return vendor && props.selectedMainCategoryId.includes(vendor?.mainCategoryId)
                      })
                      .map((tech) => {
                        const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)

                        const { isBlock, block } = checkIsBlockDaily(tech?.blockOffEmployees || [], props.date)

                        return (
                          <div className='side-technician-item tech-info' key={tech.name}>
                            <img src={tech?.profile?.avatarUrl || defaultAvatar} alt='tech' />
                            <div className='tech-info-title'>
                              <div style={{ fontWeight: 600, fontSize: 14 }}>{tech.profile?.name}</div>
                              <div style={{ fontWeight: 400, fontSize: 12 }}>{vendor?.mainCategory?.name}</div>
                              <div style={{ fontWeight: 400, fontSize: 12 }}>{vendor?.name}</div>
                            </div>
                            {isBlock && block && (
                              <div
                                onClick={() => {
                                  onSeeBlockTime(block)
                                }}
                                className='rest-block'
                                style={{ width: `${((endHour - startHour) * 100) / 2}%` }}
                              >
                                {block.reason || 'Time Block'}
                                <div>{`0${startHour}:00-${endHour + 1}:00`}</div>
                              </div>
                            )}
                          </div>
                        )
                      })
                  )}
              </div>
            )
          }
          return (
            <div key={hour} className={`column ${isThisHour ? 'col-highlight' : ''}`}>
              <span className='heading'>
                <span>
                  {hour < 10 ? `0${hour}` : hour}:00 - {hour + 1}:00
                </span>
              </span>
              {Object.entries(groupByTech)
                .filter(([key]) => key !== 'unassign')
                .map(([key, tasks]) => {
                  const taskInHour = tasks?.find((task) => moment(task.timeSlotBeginAt).get('hour') === hour)
                  const { cssStatus } = getTaskStatus(taskInHour?.status)

                  const startTime = moment(taskInHour?.timeSlotBeginAt)
                  const endTime = moment(taskInHour?.timeSlotEndAt)

                  const diffInMinutes = endTime.diff(startTime, 'minutes')
                  const bookingType = taskInHour?.booking?.type
                  const bookingLink = bookingType === BOOKING_TYPE.RECURRING ? 'contract-booking' : 'one-time-booking'

                  const tech = props.technicians.find((tech) => tech?.profile?.name === key)
                  const vendor = props.vendors.find((vendor) => vendor.id === tech?.companyId)

                  const isRestDay =
                    vendor?.operatingTime?.find((operation) => getDayNumberFromString(operation.name) === dayIndex)
                      ?.enable === false

                  const operatingOnThisDay = vendor?.operatingTime?.find(
                    (operation) => getDayNumberFromString(operation.name) === dayIndex
                  )

                  let isRest
                  if (
                    hour < moment(operatingOnThisDay?.begin, 'hh:mmA').get('hour') ||
                    hour >= moment(operatingOnThisDay?.end, 'hh:mmA').get('hour')
                  ) {
                    isRest = true
                  }

                  const { isBlock, duration, block, positionLeft } = checkIsBlockDailyPartial(
                    tech?.blockOffEmployees || [],
                    hour,
                    props.date
                  )

                  return (
                    <div className='side-technician-item' key={key}>
                      {taskInHour ? (
                        <NavLink
                          to={`/schedule/${bookingLink}?bookingId=${taskInHour?.bookingId}`}
                          target='_blank'
                          className={`task-daily-mode ${cssStatus}`}
                          style={{
                            position: 'relative',
                            width: `calc(${(diffInMinutes / 60) * 100}% + ${
                              Math.ceil(diffInMinutes / 60) * Math.ceil(diffInMinutes / 60) * 2
                            }px)`,
                            left: `${(startTime.minutes() / 60) * 100}%`
                          }}
                        >
                          <div style={{ fontWeight: 'bold' }}>{taskInHour.booking?.code}</div>
                          <div style={{ fontWeight: 'bold' }}>{taskInHour.account?.profile?.name}</div>
                          <div>{renderDesignateAddress(taskInHour)}</div>
                        </NavLink>
                      ) : null}
                      {isRestDay && hour === startHour && (
                        <div className='rest-block' style={{ width: `${(endHour - startHour) * 100}%` }}>
                          Rest day
                        </div>
                      )}
                      {isRest && (
                        <div className='rest-block by-hour block-time' style={{ width: `${100}%` }}>
                          Non-working hour
                        </div>
                      )}
                      {isBlock && duration && block && (
                        <div
                          onClick={() => {
                            onSeeBlockTime(block)
                          }}
                          className='rest-block block-time'
                          style={{ width: `${duration * 100}%`, left: `${positionLeft}%` }}
                        >
                          {block.reason || 'Time Block'}
                          <div>{`${moment(block?.begin, 'hh:mmA').format('HH:mm')}-${moment(
                            block?.end,
                            'hh:mmA'
                          ).format('HH:mm')}`}</div>
                        </div>
                      )}
                    </div>
                  )
                })
                .concat(
                  techDontHaveTask
                    .filter((tech) => props.vendors.find((vendor) => vendor.id === tech.companyId))
                    .filter((tech) => {
                      if (props.selectedMainCategoryId.length === 0) {
                        return true
                      }
                      const vendor = props.vendors.find((vendor) => vendor.id === tech.companyId)
                      return vendor && props.selectedMainCategoryId.includes(vendor?.mainCategoryId)
                    })
                    .map((tech) => {
                      const { isBlock, duration, block, positionLeft } = checkIsBlockDailyPartial(
                        tech?.blockOffEmployees || [],
                        hour,
                        props.date
                      )

                      const technichan = props.technicians.find((t) => t?.id === tech.id)
                      const vendor = props.vendors.find((vendor) => vendor.id === technichan?.companyId)

                      const operatingOnThisDay = vendor?.operatingTime?.find(
                        (operation) => getDayNumberFromString(operation.name) === dayIndex
                      )

                      let isRest
                      if (
                        hour < moment(operatingOnThisDay?.begin, 'hh:mmA').get('hour') ||
                        hour >= moment(operatingOnThisDay?.end, 'hh:mmA').get('hour')
                      ) {
                        isRest = true
                      }

                      const isRestDay =
                        vendor?.operatingTime?.find((operation) => getDayNumberFromString(operation.name) === dayIndex)
                          ?.enable === false
                      return (
                        <div className='side-technician-item' key={tech.id}>
                          {isRestDay && hour === startHour && (
                            <div
                              className='rest-block'
                              style={{
                                width: `calc(${(endHour - startHour) * 100}% + ${(endHour - startHour) * 1}px)`
                              }}
                            >
                              Rest day
                            </div>
                          )}
                          {isRest && (
                            <div className='rest-block by-hour block-time' style={{ width: `${100}%` }}>
                              Non-working hour
                            </div>
                          )}
                          {isBlock && duration && block && (
                            <div
                              onClick={() => {
                                onSeeBlockTime(block)
                              }}
                              className='rest-block block-time'
                              style={{ width: `${duration * 100}%`, left: `${positionLeft}%` }}
                            >
                              {block.reason || 'Time Block'}
                              <div>{`${moment(block?.begin, 'hh:mmA').format('HH:mm')}-${moment(
                                block?.end,
                                'hh:mmA'
                              ).format('HH:mm')}`}</div>
                            </div>
                          )}
                        </div>
                      )
                    })
                )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ScheduleCalendarDaily
